/**
Project: Voice Panel (c)
Title: Domain Setup 
Description: Component to navigate between pages to complete the DNS setup
Copyrights: This file is subject to the terms and conditions defined in file 'LICENSE.txt', which is part of this source code package.
*/
import React, { Component } from "react";
import { connect } from "react-redux";
import { Flex, Text, Divider } from "@fluentui/react-northstar";
import axios from "axios";
import PageUtil from "../../../../core/helpers/page-util";
import IntlUtil from "../../../../core/helpers/intl-util";
import PageLoader from "../../common/helpers/page-loader";
import { setSubscriberAccount } from "../../common/actions/subscriber-actions";
import { setDomainSetupProgressPage } from "../actions/domain-setup-action";
import { VoiceAdminConstants } from "../../common/settings/voice-admin-constants";
import { manageError } from "../../../../core/actions/common-actions";
import { AppPageTitle } from "../../../../core/components/app-page-title";
import ProgressIndicator from "./progess-indicator";
import Account from "./account";
import Welcome from "./welcome";
import Region from "./region";
import Domains from "./domains";
import Users from "./users";
import Summary from "./summary";

class DomainSetup extends Component {
  _isMounted = false;
  _axiosSource = axios.CancelToken.source();
  _cancelToken = { cancelToken: this._axiosSource.token };
  _intl_ns_common = "common";
  _intl_ns_vpa_domainsetup = "vpa_domainsetup";
  constructor(props) {
    super(props);
    this.state = {
      isPageDataFetched: false,
    };
  }

  setStateAsync = (state) => {
    if (this._isMounted) {
      return new Promise((resolve) => {
        this.setState(state, resolve);
      });
    }
  };

  async componentDidMount() {
    this._isMounted = true;
    PageUtil.scrollToTop();
    await this.loadPageData();
  }

  componentWillUnmount() {
    this._isMounted = false;
    this._axiosSource.cancel(
      IntlUtil.getText(
        this._intl_ns_common,
        "notification.warning.requestCancelled"
      )
    );
  }

  loadPageData = async () => {
    try {
      await this.setStateAsync({ isPageDataFetched: false });
      await this.props.setSubscriberAccount(this._cancelToken);
      await this.props.setDomainSetupProgressPage(
        VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.WELCOME
      );
      await this.setStateAsync({ isPageDataFetched: true });
    } catch (err) {
      await manageError(err, this.props.history);
    }
  };

  renderPage = () => {
    if (
      this.props.domainSetupProgressPage ===
      VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.WELCOME
    ) {
      return <Welcome {...this.props} />;
    } else {
      let pageComponent = null;
      switch (this.props.domainSetupProgressPage) {
        case VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.ACCOUNT:
          pageComponent = <Account {...this.props} />;
          break;
        case VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.REGION:
          pageComponent = <Region {...this.props} />;
          break;
        case VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.DOMAINS:
          pageComponent = <Domains {...this.props} />;
          break;
        case VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.USERS:
          pageComponent = <Users {...this.props} />;
          break;
        case VoiceAdminConstants.DOMAIN_SETUP.PROGRESS.SUMMARY:
          pageComponent = <Summary {...this.props} />;
          break;
        default:
          pageComponent = pageComponent = <></>;
          break;
      }
      return (
        <>
          <ProgressIndicator {...this.props} />
          <Divider size={1} className="vpa-domain-setup-divider" />
          {pageComponent}
        </>
      );
    }
  };

  render() {
    return (
      <>
        <AppPageTitle
          pageTitle={IntlUtil.getText(
            this._intl_ns_vpa_domainsetup,
            "title.domainSetup"
          )}
        />
        <Flex column className="page-wrapper">
          <Flex column className="page-title-wrapper">
            <Text className="page-title-text">
              {IntlUtil.getText(
                this._intl_ns_vpa_domainsetup,
                "content.domainSetup"
              )}
            </Text>
          </Flex>
          <Flex column className="page-content p-t-5">
            <PageLoader
              status={this.state.isPageDataFetched}
              size="medium"
              labelPosition="below"
              label={IntlUtil.getText(
                this._intl_ns_common,
                "content.loadingInprogress"
              )}
              type="full-center"
            >
              {this.renderPage()}
            </PageLoader>
          </Flex>
        </Flex>
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  subscriberAccount: state.subscriberStore.subscriberAccount,
  domainSetupProgressPage: state.domainSetupStore.domainSetupProgressPage,
});

const mapActionToProps = {
  setSubscriberAccount,
  setDomainSetupProgressPage,
};

export default connect(mapStateToProps, mapActionToProps)(DomainSetup);
